import React, { useEffect } from 'react';

import { FieldValues } from 'react-hook-form';
import { makeStyles } from 'tss-react/mui';
import { Box, Grid } from '@mui/material';

import { OhsFormSettings } from 'global-components/form/services/OhsFormModels';
import OhsSelectField from 'global-components/form/fields/OhsSelectField';
import OhsDateRangePickerNew from 'global-components/form/fields/OhsDateRangePickerNew';
import { DateDueKey } from 'global-services/register/DateDueModels';

interface Props {
  fieldId: string;
  typeId: string;
  ohsFormSettings: OhsFormSettings<FieldValues>;
  label: string;
  isSearch?: boolean;
  options?: { name: string; value: string }[];
}

const useStyles = makeStyles()(() => ({
  dateWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginTop: '10px',
  },
  dateLabel: {
    fontFamily: 'Lato',
    fontSize: '14px',
    lineHeight: '1.4285em',
    fontWeight: 'bold',
  },
}));

export default function OhsDateDueFilter(props: Props) {
  const { classes } = useStyles();
  const type = props.ohsFormSettings.useFormMethods.watch(props.typeId) ?? null;
  const dateDue = props.ohsFormSettings.useFormMethods.watch(props.fieldId) ?? null;
  const withOptions = (props?.options || []).length > 0;

  useEffect(() => {
    if (type !== DateDueKey.Custom) {
      props.ohsFormSettings.useFormMethods.setValue(props.fieldId, type);
    } else {
      const currentForm = props.ohsFormSettings.useFormMethods.getValues();
      const newForm = {
        ...currentForm,
        [props.fieldId]: {
          start: dateDue?.start || '',
          end: dateDue?.end || '',
        },
      };
      props.ohsFormSettings.useFormMethods.reset(newForm);
    }
    if (!type) {
      props.ohsFormSettings.useFormMethods.unregister(props.fieldId);
    }
  }, [type]);

  return (
    <Grid item xs={12}>
      {withOptions && (
        <OhsSelectField
          title={props.label}
          id={props.typeId}
          required={false}
          options={props.options || []}
          ohsFormSettings={props.ohsFormSettings}
        />
      )}
      {(type === DateDueKey.Custom || !withOptions) && (
        <>
          {/* only show when select is hidden */}
          {!withOptions && props.label && (
            <Box mb={1} style={{ fontWeight: 'bolder' }}>
              {props.label}
            </Box>
          )}
          <Box className={classes.dateWrapper}>
            <OhsDateRangePickerNew
              ohsFormSettings={props.ohsFormSettings}
              id={props.fieldId}
              isSearch={props.isSearch}
              required={type === DateDueKey.Custom && withOptions}
            />
          </Box>
        </>
      )}
    </Grid>
  );
}

OhsDateDueFilter.defaultProps = {
  isSearch: undefined,
  options: undefined,
};
